export const useStudentWritingCompanionEntitlement = (
  studentId: MaybeRefOrGetter<string | undefined>,
  classroomId: MaybeRefOrGetter<string | undefined>
) => {
  const store = useWritingCompanionEntitlementsStore();
  const currentStudentId = computed(() => toValue(studentId));
  const currentClassroomId = computed(() => toValue(classroomId));
  const record = computed(() => {
    const id = currentStudentId.value;
    const classId = currentClassroomId.value;
    return id && classId ? store.records[store.key(id, classId)] : undefined;
  });
  const isLoading = computed(
    () =>
      currentStudentId.value != undefined &&
      currentClassroomId.value != undefined &&
      (record.value?.loaded !== true || record.value?.isLoading === true)
  );
  const hasPurchased = computed(() => record.value?.hasPurchased === true);
  const status = computed(() => record.value?.status);
  const error = computed(() => record.value?.error);
  const refresh = async () => {
    const id = currentStudentId.value;
    const classId = currentClassroomId.value;
    if (id && classId) await store.load(id, classId, true);
  };

  watch(
    [currentStudentId, currentClassroomId],
    ([id, classId]) => {
      if (id && classId) store.load(id, classId);
    },
    { immediate: true }
  );

  return {
    isLoading: readonly(isLoading),
    hasPurchased: readonly(hasPurchased),
    status: readonly(status),
    error: readonly(error),
    refresh,
  };
};
